// Asset
export const SHOW_UPLOADS = 'SHOW_UPLOADS';
export const SELECTED_ASSET = 'SELECTED_ASSET';
export const SELECTED_ASSET_METADATA = 'SELECTED_ASSET_METADATA';
export const REVISIONS = 'REVISIONS';
export const DRAGGING_ASSET = 'DRAGGING_ASSET';
export const ASSET_STORE = 'ASSET_STORE';
export const ASSETLIST_PAGE_NUMBER = 'ASSETLIST_PAGE_NUMBER';
export const CONTEXT_INFO = 'CONTEXT_INFO';
export const ASSET_FILTERS = 'ASSET_FILTERS';
export const MODE = 'MODE';
export const ASSET_LIST_BLOCK_INSTANCE = 'ASSET_LIST_BLOCK_INSTANCE';
export const LOADED_TREE_ITEMS = 'LOADED_TREE_ITEMS';
// Collection
export const COLLECTIONS = 'COLLECTIONS';
export const SELECTED_COLLECTION = 'SELECTED_COLLECTION';
export const SELECTED_COLLECTION_ID = 'SELECTED_COLLECTION_ID';
export const COLLECTION_COUNT = 'COLLECTION_COUNT';
export const COLLECTION_USERS = 'COLLECTION_USERS';
export const COLLECTION_METADATA = 'COLLECTION_METADATA';
export const ARE_UPLOADS_DISABLED = 'ARE_UPLOADS_DISABLED';
export const COLLECTION_ASSETS = 'COLLECTION_ASSETS';
export const PERMISSIONS = 'PERMISSIONS';

// Image
export const ASSET_PREVIEW_INFO = 'ASSET_PREVIEW_INFO';
export const ASSET_SCALE_INFO = 'ASSET_SCALE_INFO';

// Video
export const VIDEO_DURATION = 'VIDEO_DURATION';
export const VIDEO_FRAME_RATE = 'VIDEO_FRAME_RATE';
export const VIDEO_CONTROLLER = 'VIDEO_CONTROLLER';
export const SYNC_VIDEOS = 'SYNC_VIDEOS';
export const SHOW_METADATA_TIMELINE = 'SHOW_METADATA_TIMELINE';
export const ACTIVE_TIMELINE_NODE = 'ACTIVE_TIMELINE_NODE';
export const ONLOCATE_VIA_ADV_SEARCH = 'ONLOCATE_VIA_ADV_SEARCH';
export const AI_METADATA = 'AI_METADATA';
export const KEYFRAME_METADATA = 'KEYFRAME_METADATA';
export const CLIP_FROM_TIMELINE = 'CLIP_FROM_TIMELINE';
export const WAVEPLAYER_MODE = 'WAVEPLAYER_MODE';
// Multipage
export const MULTIPAGE_ASSET_CURRENT_PAGE = 'MULTIPAGE_ASSET_CURRENT_PAGE';
export const MULTIPAGE_ASSET_NUM_PAGES = 'MULTIPAGE_ASSET_NUM_PAGES';

// Comment
export const COMMENTS = 'COMMENTS';
export const SHOW_COMMENTS = 'SHOW_COMMENTS';
export const ACTIVE_COMMENT_ID = 'ACTIVE_COMMENT_ID';
export const RECENT_DELETED_COMMENT_ID = 'RECENT_DELETED_COMMENT_ID';
export const COMMENT_FILTER_BY = 'COMMENT_FILTER_BY';
export const COMMENT_TEXT = 'COMMENT_TEXT';
export const WAVEPLAYER_COMMENT = 'WAVEPLAYER_COMMENT';
export const EXPANDED_THREAD_IDS = 'EXPANDED_THREAD_IDS';

// Drawing
export const CROP = 'CROP';
export const TEXT_DRAWINGS = 'TEXT_DRAWINGS';

// Global
export const TOAST = 'TOAST';
export const URLS = 'URLS';
export const DRAWING_CANVAS = 'DRAWING_CANVAS';
export const GLOBAL_PROGRESS = 'GLOBAL_PROGRESS';
export const GLOBAL_SPINNER = 'GLOBAL_SPINNER';
export const REVIEW_SERVER_AUTH_DATA = 'REVIEW_SERVER_AUTH_DATA';
export const KEYDOWN_CONFIGS = 'KEYDOWN_CONFIGS';
export const IS_CLIPMODE_DRAGGING = 'IS_CLIPMODE_DRAGGING';
export const PROP_NAME_TO_PROP_INFO = 'PROP_NAME_TO_PROP_INFO';
export const GROUP_CODE_TO_GROUP_INFO = 'GROUP_CODE_TO_GROUP_INFO';
export const PREVENT_MEDIA_AUTOPLAY = 'PREVENT_MEDIA_AUTOPLAY';
export const SERVER_SPEC = 'SERVER_SPEC';
export const PWD = 'PWD';
export const IS_DRAGGING_FILE = 'IS_DRAGGING_FILE';
export const NOTIFICATION_INFO = 'NOTIFICATION_INFO';
export const UPLOAD_SCHEDULER = 'UPLOAD_SCHEDULER';
export const SHOW_FOLDERNAV_VIEW = 'SHOW_FOLDERNAV_VIEW';
export const SHOW_TREE_VIEW = 'SHOW_TREE_VIEW';
export const ALL_FILES_OPTION = 'ALL_FILES_OPTION';
export const SHOW_ALL_FILES = 'SHOW_ALL_FILES';
export const SHOW_SPOTLIGHT_FILES = 'SHOW_SPOTLIGHT_FILES';
export const BREADCRUMB_ASSETS = 'BREADCRUMB_ASSETS';
export const GLOBAL_SEARCH_INFO = 'GLOBAL_SEARCH_INFO';
export const FAV_ITEM_DETAIL_MAP = 'FAV_ITEM_DETAIL_MAP';
export const SPOTLIGHT_CONTENT = 'SPOTLIGHT_CONTENT';
export const SHOW_NOTIFICATION_PANEL = 'SHOW_NOTIFICATION_PANEL';
export const SUCCESS_DIALOG_MSG = 'SUCCESS_DIALOG_MSG';

// Reporting
export const REPORTS = 'REPORTS';

//OAuth
export const OAUTH_LOGOUT_STATE = 'OAUTH_LOGOUT_STATE';

// Advanced search
export const ADV_SRCH_ASSETS = 'ADV_SRCH_ASSETS';
export const ADV_SRCH_COLLECTIONS = 'ADV_SRCH_COLLECTIONS';
export const ADV_SRCH_METADATA = 'ADV_SRCH_METADATA';

// AI
export const DEFAULT_ENGINE_NAME = 'Transcription';
export const SELECTED_ASSET_AI_METADATA = 'SELECTED_ASSET_AI_METADATA';
export const SET_ACTIVE_METADATA_OBJECT = 'SET_ACTIVE_METADATA_OBJECT';
export const SET_LOCATE_ACTIVE_ID = 'SET_LOCATE_ACTIVE_ID';
export const TEMP_VIDEO_AI_DATA = 'TEMP_VIDEO_AI_DATA';
// DND
export const DRAG_PREVIEW = 'DRAG_PREVIEW';
export const DRAG_ITEMS = 'DRAG_ITEMS';

// Upload
export const UPLOAD_FINISHED = 'UPLOAD_FINISHED';

// Search/Filter
export const CATEGORY_LIST = 'CATEGORY_LIST';

// Jobs
export const JOBS = 'JOBS'; // Should we put all jobs into one big array?
export const ASSET_UPLOAD_JOBS = 'ASSET_UPLOAD_JOBS';
export const COLLECTION_UPLOAD_JOBS = 'COLLECTION_UPLOAD_JOBS';
export const DOWNLOAD_JOBS = 'DOWNLOAD_JOBS';

//Time
export const FULL_TIME_FORMAT = 'FULL_TIME_FORMAT';
